/**
 * ## Gestures Controller
 *
 * @module src/controllers/gestures
 */

'use strict';

const tabs = require('../../controllers/tabs');
const conf = require('../../config');

const threshold = 120; // in px;

const gest = {
    start: {
        time: 0,
        x: 0,
        y: 0,
    },
    end: {
        time: 0,
        x: 0,
        y: 0,
    },
};

/** Init
 */
const init = (kd) => {
    if (conf.vars.ui === 'standard' && kd.usage !== 'x_chart' && kd.usage !== 'g_chart' &&
    kd.usage !== 'x_section' && kd.usage !== 'g_section') {
        $('#layout_main').unbind();
        $('#layout_main').on('mousedown touchstart', (event) => {
            // event.preventDefault();
            gest.start.time = Date.now();
            if (event.type === 'mousedown') {
                gest.start.x = event.pageX;
                gest.start.y = event.pageY;
            } else {
                gest.start.x = event.changedTouches[0].pageX;
                gest.start.y = event.changedTouches[0].pageY;
            }
        });

        $('#layout_main').on('mouseup touchend', (event) => {
            // event.preventDefault();
            gest.end.time = Date.now();
            if (event.type === 'mouseup') {
                gest.end.x = event.pageX;
                gest.end.y = event.pageY;
            } else {
                gest.end.x = event.changedTouches[0].pageX;
                gest.end.y = event.changedTouches[0].pageY;
            }
            detect(kd, gest, event);
        });
    }
};

const detect = (kd, gesture, event) => {
    if (gesture.end.time - gesture.start.time < 300 &&
        Math.abs(gesture.end.x - gesture.start.x) > threshold) {
        event.preventDefault();
    }
    if (gesture.end.time - gesture.start.time < 300) {
        // From standard, open wide. right to left
        if (gesture.start.x > conf.vars.viewportWidth - 220 &&
            gesture.start.x - gesture.end.x > threshold) {
            if (tabs.layout.getIsMin()) {
                tabs.layout.sidebarMinClose(conf.vars.interfaceSpeed / 2);
            } else if (!tabs.layout.getIsExpanded()) {
                tabs.checkWideTab(kd);
            }
        // From standard, open min. left to right
        } else if (gesture.start.x > conf.vars.viewportWidth - 220 &&
            gesture.end.x - gesture.start.x > threshold / 1.5) {
            if (!tabs.layout.getIsExpanded()) {
                tabs.layout.sidebarMinOpen(conf.vars.interfaceSpeed / 2);
            }
        // From min, open standard. right to left
        } else if (gesture.start.x > conf.vars.viewportWidth - 80 &&
            gesture.start.x - gesture.end > threshold) {
            if (tabs.layout.getIsMin()) {
                tabs.layout.sidebarMinClose(conf.vars.interfaceSpeed / 2);
            }
        // From max, close to standard. left to right
        } else if (gesture.end.x - gesture.start.x > threshold) {
            if (tabs.layout.getIsExpanded()) {
                tabs.checkStandardTab(kd);
                // tabs.layout.sidebarMaxClose(0.2);
            }
        }
    }
};

module.exports = {
    init,
};




/** WEBPACK FOOTER **
 ** ./src/controllers/gestures/index.js
 **/